import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

const IcapNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="icap" />;
};

export default IcapNode;
